<script lang="ts" setup>

</script>

<template>
  <div class="h-full w-full min-h-[80vh] flex flex-col justify-center ">
    <UserForgottenPassword class="mb-32" />
  </div>
</template>
